// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Yxq4","image":"Header_image__2LivM","name":"Header_name__3gZBo","info":"Header_info__RVAi8","infoRow":"Header_infoRow__2FjFy"};